<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch2" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="VST"><span aria-label="3" id="pg_3" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch2" id="ch2" title="Link target outside of Sample"><b><i>We Have Work to Do</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">She is kind, in a no-nonsense way.</p>
<p class="V">It feels strange speaking to a medical</p>
<p class="V">professional about the personal and broken</p>
<p class="V">parts <i>inside</i> me. I’m on the other end of the</p>
<p class="V">desk. <i>I’m used to talking one on one with my</i></p>
<p class="V"><i>patients.</i> Yet here I am … sick. <i>I want you to</i></p>
<p class="V"><i>write down the first thing that comes to your</i></p>
<p class="V"><i>mind and we’ll take it from there.</i> She wants</p>
<p class="V">me to use my love of words as therapy. She</p>
<p class="V">hands me a canary yellow notebook, a tool to</p>
<p class="V">help me release my emotions. She doesn’t know</p>
<p class="V">I’ve already been doing this for over 30 years.</p>
<p class="VSB">She tells me to bring it with me each visit.</p>
<p class="V">The following day, when she reads my first</p>
<p class="V">entry, she sighs. “W<i>e have work to do.</i>”</p>
</blockquote>
<section epub:type="division">
<h2 class="H1"><b><i>I tried so hard, but I could never</i></b></h2>
</section>
<section epub:type="division">
<h2 class="H1"><b><i>make this world love me.</i></b></h2>
</section>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?313ce0de